<template>
  <div class="goods-detail-page container">
    <div v-if="loading" class="my-loading"><i class="el-icon-loading"></i></div>
    <div v-else-if="detail" class="o-detail-con relative">
      <div class="o-main o-d-block">
        <div class="he-tips">
          <b style="font-size: 16px">产品详情</b>
          <div class="handle-s">
            <span
              class="pointer gray-color"
              @click="redirect('/goods/edit?id=' + detail.id)"
              >编辑</span
            >
          </div>
        </div>
        <table class="table">
          <tr>
            <td class="td-1">标题</td>
            <td class="td-2">
              <div
                style="
                  word-wrap: break-word;
                  word-break: break-all;
                  white-space: normal;
                  width: 700px;
                "
              >
              {{ detail.title }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">英文</td>
            <td class="td-2">
              <div
                style="
                  word-wrap: break-word;
                  word-break: break-all;
                  white-space: normal;
                  width: 700px;
                "
              >
              {{ detail.title_en }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">短标题</td>
            <td class="td-2">
              <div
                style="
                  word-wrap: break-word;
                  word-break: break-all;
                  white-space: normal;
                  width: 700px;
                "
              >
              {{ detail.title_short }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">SEO</td>
            <td class="td-2">
              <div
                style="
                  word-wrap: break-word;
                  word-break: break-all;
                  white-space: normal;
                  width: 700px;
                "
              >
              {{ detail.title_seo }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">轮播图</td>
            <td class="td-2">
              <div>
                <el-upload
                  :action="
                    '/seller-api/v1/pub/helpers/upload-file-seller?dir_tag=goods&token=' +
                    token
                  "
                  list-type="picture-card"
                  :on-success="handleSuccessThumb"
                  :on-preview="handlePictureCardPreviewThumb"
                  :file-list="detail.images"
                  :on-remove="handleRemoveThumb"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </div>
            </td>
          </tr>
          <tr v-if="!detail.is_phone_case">
            <td class="td-1">展示变体图</td>
            <td class="td-2">
              <div>
                <el-switch
                  v-model="detail.enable_variant_image_bool"
                  @change="enable_variant_image"
                  active-color="#13ce66"
                ></el-switch>
              </div>
            </td>
          </tr>
          <tr v-if="detail.is_phone_case">
            <td class="td-1">背景颜色</td>
            <td class="td-2">
              <div>
                <el-switch
                  v-model="detail.enable_bg_color_bool"
                  @change="enableBgColor"
                ></el-switch>
              </div>
            </td>
          </tr>
          <tr v-if="detail.is_phone_case">
            <td class="td-1">抠图型号</td>
            <td class="td-2">
              <div class="relative">
                <span class="el-icon-edit pointer" @click="editModelPop = true">
                  {{ detail.model_name }}
                </span>
                <div
                  style="position: absolute; left: 155px; top: 0"
                  v-if="editModelPop"
                >
                  <el-select
                    v-model="detail.diy_brand_id"
                    placeholder="选择品牌"
                    size="mini"
                    class="w130"
                    clearable
                    @change="changeBrand"
                  >
                    <el-option
                      v-for="item in brand_options"
                      :key="item.id"
                      :label="item.brand_name_en"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="detail.diy_series_id"
                    placeholder="选择系列"
                    size="mini"
                    class="w130"
                    clearable
                    @change="changeSeries"
                  >
                    <el-option
                      v-for="item in series_options"
                      :key="item.id"
                      :label="item.series_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="detail.diy_model_id"
                    placeholder="选择型号"
                    size="mini"
                    class="w200"
                    clearable
                    @change="changeModel"
                  >
                    <el-option
                      v-for="item in model_options"
                      :key="item.id"
                      :label="item.model_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="detail.is_phone_case">
            <td class="td-1">有货型号</td>
            <td class="td-2">
              <div style="white-space: normal">
                <el-checkbox-group v-model="detail.adapters_model_ids">
                  <el-checkbox
                    :label="model.id"
                    v-for="(model, index_m) in model_options"
                    :key="index_m"
                    >{{ model.model_name }}</el-checkbox
                  >
                </el-checkbox-group>
                <el-checkbox 
                  v-model="is_adapters_model_all" 
                  @change="handleSelectAll">全选</el-checkbox>
                <el-tag
                  size="small"
                  type="danger"
                  class="pointer"
                  v-loading="adapters_models_loading"
                  @click="adapters_models"
                  >保存</el-tag
                >
              </div>
            </td>
          </tr>
          <tr v-if="detail.is_phone_case">
            <td class="td-1">不适配模板</td>
            <td class="td-2">
              <div style="white-space: normal">
                <el-checkbox-group v-model="detail.disabled_template_tag_ids" @change="save_disabled_template_tag_ids">
                  <el-checkbox :label="t.id" v-for="(t, index_m) in template_tag_options" :key="index_m" >{{ t.tag_name_en }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </td>
          </tr>
          <tr v-if="detail.is_phone_case">
            <td class="td-1">推荐模板模板</td>
            <td class="td-2">
              <div style="white-space: normal">
                <el-checkbox-group v-model="detail.recommend_template_tag_ids" @change="save_recommend_template_tag_ids">
                  <el-checkbox :label="t.id" v-for="(t, index_m) in template_tag_options" :key="index_m" >{{ t.tag_name_en }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">SKU</td>
            <td class="td-2">
              <div style="overflow: hidden">
                <el-table :data="detail.sku_list">
                  <el-table-column prop="photo_main" label="Image" width="90">
                    <template slot-scope="scope">
                      <el-upload
                        class="avatar-uploader"
                        :action="
                          '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-image&token=' +
                          token
                        "
                        :show-file-list="false"
                        :on-success="
                          (response, file, fileList) => {
                            return uploadSkuImageSuccess(
                              response,
                              file,
                              fileList,
                              scope.row
                            );
                          }
                        "
                      >
                        <img
                          v-if="scope.row.image"
                          :src="scope.row.image"
                          style="width: 64px; height: 64px"
                        />
                        <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                          style="width: 64px; height: 64px; line-height: 64px"
                        ></i>
                      </el-upload>
                      <el-popover
                        v-if="scope.row.image"
                        placement="bottom"
                        trigger="click">
                        <div style="padding:30px;">
                          <el-select v-model="scope.row.apply_sku_mod" multiple style="width:166px;">
                            <el-option v-for="ats in detail.attributes" :key="ats.name" :label="ats.name" :value="ats.name"></el-option>
                          </el-select> 
                          <el-button @click="to_apply_sku_image(scope.row)" :disabled="!scope.row.apply_sku_mod">确 定</el-button>
                        </div>
                        <el-button slot="reference" size="mini">应用</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="line_image"
                    label="Line"
                    width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-upload
                        class="avatar-uploader"
                        :action="
                          '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-line&token=' +
                          token
                        "
                        :show-file-list="false"
                        :on-success="
                          (response, file, fileList) => {
                            return uploadSkuLineImageSuccess(
                              response,
                              file,
                              fileList,
                              scope.row
                            );
                          }
                        "
                      >
                        <img
                          v-if="scope.row.line_image"
                          :src="scope.row.line_image"
                          style="width: 32px; height: 64px"
                        />
                        <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                          style="width: 64px; height: 64px; line-height: 64px"
                        ></i>
                      </el-upload>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="mask_image"
                    label="Mask"
                    width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-upload
                        class="avatar-uploader"
                        :action="
                          '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-mask&token=' +
                          token
                        "
                        :show-file-list="false"
                        :on-success="
                          (response, file, fileList) => {
                            return uploadSkuMaskImageSuccess(
                              response,
                              file,
                              fileList,
                              scope.row
                            );
                          }
                        "
                      >
                        <img
                          v-if="scope.row.mask_image"
                          :src="scope.row.mask_image"
                          style="width: 32px; height: 64px"
                        />
                        <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                          style="width: 64px; height: 64px; line-height: 64px"
                        ></i>
                      </el-upload>
                      <a v-if="scope.row.mask_image" @click="on_remove_sku_mask_image(scope.row)" class="gray-color pointer">删除</a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="camera_image"
                    label="Camera"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="clearfix">
                        <ul class="clearfix fl">
                          <li
                            v-for="(came, index_came) in scope.row
                              .camera_images"
                            :key="index_came"
                            style="
                              width: 70px;
                              text-align: center;
                              float: left;
                              position: relative;
                            "
                          >
                            <img
                              :src="came.file_oss"
                              style="width: 32px; height: 64px"
                            />
                            <el-input
                              size="mini"
                              v-model="came.color_value"
                              @blur="changeCameraColorValue(scope.row, came)"
                            ></el-input>
                            <i
                              class="el-icon-close"
                              style="
                                position: absolute;
                                right: 0;
                                top: 0;
                                cursor: pointer;
                              "
                              @click="
                                removeCameraImage(scope.row.id, came.file_id)
                              "
                            ></i>
                          </li>
                        </ul>
                        <el-upload
                          class="avatar-uploader fl"
                          :action="
                            '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-camera&token=' +
                            token
                          "
                          :show-file-list="false"
                          :on-success="
                            (response, file, fileList) => {
                              return uploadSkuCameraImageSuccess(
                                response,
                                file,
                                fileList,
                                scope.row
                              );
                            }
                          "
                        >
                          <i
                            class="el-icon-plus avatar-uploader-icon"
                            style="width: 64px; height: 64px; line-height: 64px"
                          ></i>
                        </el-upload>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="camera_image2"
                    label="Camera2(Glass only)"
                    width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="clearfix">
                        <ul class="clearfix fl">
                          <li
                            v-for="(came, index_came) in scope.row
                              .camera2_images"
                            :key="index_came"
                            style="
                              width: 70px;
                              text-align: center;
                              float: left;
                              position: relative;
                            "
                          >
                            <img
                              :src="came.file_oss"
                              style="width: 32px; height: 64px"
                            />
                            <el-input
                              size="mini"
                              v-model="came.color_value"
                              @blur="changeCamera2ColorValue(scope.row, came)"
                            ></el-input>
                            <i
                              class="el-icon-close"
                              style="
                                position: absolute;
                                right: 0;
                                top: 0;
                                cursor: pointer;
                              "
                              @click="
                                removeCamera2Image(scope.row.id, came.file_id)
                              "
                            ></i>
                          </li>
                        </ul>
                        <el-upload
                          class="avatar-uploader fl"
                          :action="
                            '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-camera&token=' +
                            token
                          "
                          :show-file-list="false"
                          :on-success="
                            (response, file, fileList) => {
                              return uploadSkuCamera2ImageSuccess(
                                response,
                                file,
                                fileList,
                                scope.row
                              );
                            }
                          "
                        >
                          <i
                            class="el-icon-plus avatar-uploader-icon"
                            style="width: 64px; height: 64px; line-height: 64px"
                          ></i>
                        </el-upload>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="prompt_style_image"
                    label="Style Image"
                    width="155"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-upload
                        class="avatar-uploader"
                        :action="
                          '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-style-image&token=' +
                          token
                        "
                        :show-file-list="false"
                        :on-success="
                          (response, file, fileList) => {
                            return upload_sku_prompt_style_image_success(
                              response,
                              file,
                              fileList,
                              scope.row
                            );
                          }
                        "
                      >
                        <img
                          v-if="scope.row.prompt_style_image"
                          :src="scope.row.prompt_style_image"
                          style="width: 133px;"
                        />
                        <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                          style="width: 64px; height: 64px; line-height: 64px"
                        ></i>
                      </el-upload>
                      <a v-if="scope.row.prompt_style_image" @click="on_remove_sku_prompt_style_image(scope.row)" class="gray-color pointer">删除</a>
                    </template>
                  </el-table-column>
                  <el-table-column
                  prop="sku_layers"
                  label="Layers"
                  min-width="256"
                  align="center"
                >
                  <template slot-scope="scope">
                    <ul class="clearfix">
                      <li 
                      style="float:left;width:100px;height:100px;border:1px solid #dfdfdf;text-align:center;margin-right:5px;position:relative;"
                      v-for="(layer, index_layer) in scope.row.layers" 
                      :key="index_layer"
                      >
                        <p>{{layer.layer_type}}</p>
                        <i class="el-icon-edit pointer" style="position:absolute;left:10px;bottom:10px;" @click="to_edit_layer(scope.row.id, layer)"></i>
                        <i class="el-icon-close pointer" style="position:absolute;right:10px;bottom:10px;" @click="remove_layer(layer.id)"></i>
                      </li>
                    </ul>
                    <el-tag class="pointer" @click="to_edit_layer(scope.row.id, null)">+新增</el-tag>
                    <el-popover
                      v-if="scope.row.layers.length > 0"
                      placement="bottom"
                      trigger="click">
                      <div style="padding:30px;">
                        <el-select v-model="scope.row.apply_layer_mod" :multiple="true" style="width:166px;">
                          <el-option v-for="ats in detail.attributes" :key="ats.name" :label="ats.name" :value="ats.name"></el-option>
                        </el-select> 
                        <el-button @click="to_apply_layer(scope.row)" :disabled="!scope.row.apply_layer_mod">确 定2</el-button>
                      </div>
                      <el-button slot="reference" size="mini">应用</el-button>
                    </el-popover>
                  </template>
                  </el-table-column>
                  <!-- <el-table-column prop="shopify_variant_id" label="shopify-sku" width="277" align="center">
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.shopify_variant_id"
                        @change="relationShopifySku(scope.row)"
                        clearable
                        filterable
                        style="width: 240px"
                        size="small"
                      >
                        <el-option
                          v-for="sku in shopify_sku_options"
                          :key="sku.variant_id"
                          :label="sku.product_title + '-' + sku.title"
                          :value="sku.variant_id"
                        >
                          <div
                            style="
                              height: 32px;
                              line-height: 32px;
                              border-bottom: 1px solid #dfdfdf;
                            "
                          >
                            <img :src="sku.image_src" style="width: 32px; height: 32px" />
                            <span>{{ sku.product_title + "|" + sku.title }}</span>
                          </div>
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column> -->
                  <!-- <el-table-column
                    prop="camera_image"
                    label="产品图"
                    min-width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div class="clearfix">
                        <ul class="clearfix fl">
                          <li
                            v-for="(came, index_came) in scope.row.sku_images"
                            :key="index_came"
                            style=" width: 70px;text-align: center; float: left;position: relative;">
                            <img :src="came.file_oss" style="width: 50px; max-height: 70px"/>
                            <i class="el-icon-close" style=" position: absolute; right: 0; top: 0; cursor: pointer;" @click="removeSkuImage(scope.row, index_came)"></i>
                          </li>
                        </ul>
                        <el-upload
                          class="avatar-uploader fl"
                          :action=" '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=sku-camera&token=' +  token "
                          :show-file-list="false"
                          :on-success="
                            (response, file, fileList) => {
                              return uploadSkuImagesSuccess(
                                response,
                                file,
                                fileList,
                                scope.row
                              );
                            }
                          "
                        >
                          <i
                            class="el-icon-plus avatar-uploader-icon"
                            style="width: 64px; height: 64px; line-height: 64px"
                          ></i>
                        </el-upload>
                      </div>
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="price" label="Spec" width="388px">
                    <template slot-scope="scope222">
                      <section v-if="scope222.row.sku_code_arr">
                        <el-input size="mini" v-model="scope222.row.sku_code_arr[spec2_index]" disabled v-for="(spec2, spec2_index) in scope222.row.sku_code_arr" :key="spec2_index">
                          <template slot="prepend">{{scope222.row.sku_name_arr[spec2_index]}}</template>
                        </el-input>
                      </section>
                      <el-input size="mini" v-model="scope222.row.price" style="width:309px;" @blur="change_field_price(scope222.row, 'price')">
                        <template slot="prepend">price</template>
                      </el-input>
                      <el-input size="mini" v-model="scope222.row.price_original" style="width:309px;" @blur="change_field_price(scope222.row, 'price_original')">
                        <template slot="prepend">price_original</template>
                      </el-input>
                      <el-input size="mini" v-model="scope222.row.vat_target_price" style="width:309px;" @blur="change_field_price(scope222.row, 'vat_target_price')">
                        <template slot="prepend">vat_target_price</template>
                      </el-input>
                      <el-input size="mini" v-model="scope222.row.vat_local_price" style="width:309px;" @blur="change_field_price(scope222.row, 'vat_local_price')">
                        <template slot="prepend">vat_local_price</template>
                      </el-input>
                      <el-input size="mini" v-model="scope222.row.count_stock" style="width:309px;" @blur="setSkuStock(scope.row)">
                        <template slot="prepend">stock</template>
                      </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status_bool" label="Active" width="166">
                    <template slot-scope="scope">
                      <el-radio
                        style="margin-bottom: 10px;"
                        v-model="detail.default_sku_id"
                        :label="scope.row.id"
                        @change="setSkuDefault"
                        >默认</el-radio
                      >
                      <el-switch
                        v-model="scope.row.status_bool"
                        active-color="#13ce66"
                        inactive-color="#cccccc"
                        active-text="Active"
                        @change="setSkuStatus(scope.row)"
                      ></el-switch>
                      <el-switch
                        v-model="scope.row.enable_preview_btn_bool"
                        active-color="#13ce66"
                        inactive-color="#cccccc"
                        active-text="Preview"
                        @change="setSkuPreviewBtnStatus(scope.row)"
                      ></el-switch>
                      <el-button size="mini" class="pointer" style="margin-top:10px;" @click="pop_sku_models(scope.row)" v-if="detail.is_phone_case">型号图</el-button>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="id" label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <span class="pointer gray-color" @click="removeSku(scope.row.id)">删除</span>
                                <span class="pointer gray-color" @click="toEditSku(scope.row.id)">编辑</span>
                            </template>                
                        </el-table-column> -->
                </el-table>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">标签</td>
            <td class="td-2">
              <el-tag
                v-for="tag in detail.tags"
                :key="tag.name"
                closable
                type="info"
                @close="removeTag(tag)"
                style="margin-right: 10px"
              >
                {{ tag.name }}
              </el-tag>
              <el-tag class="pointer" @click="toAddTag">+</el-tag>
            </td>
          </tr>
          <tr>
            <td class="td-1">视频/封面</td>
            <td class="td-2">
              <el-upload
                class="avatar-uploader"
                :action="
                  '/seller-api/v1/pub/helpers/upload-file-and-save-design?dir_tag=goods-video&token=' +
                  token
                "
                :show-file-list="false"
                :on-success="uploadVideoImageSuccess"
              >
                <img
                  v-if="detail.video_cover"
                  :src="detail.video_cover"
                  style="width: 100px; height: auto;"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="width: 100px; height: 100px; line-height: 100px;font-size: 16px;"
                >封面</i>
              </el-upload>
              <el-input v-model="detail.video_url" placeholder="视频链接，https://" class="w500" @blur="saveField(detail.id, 'video_url', detail.video_url)"></el-input>
            </td>
          </tr>
          <tr>
            <td class="td-1">商品描述</td>
            <td class="td-2">
              <div
                v-html="detail.describes"
                style="
                  width: 500px;
                  overflow: hidden;
                  padding-left: 20px;
                  box-sizing: border-box;
                "
              ></div>
            </td>
          </tr>
          <tr>
            <td class="td-1">授权用户</td>
            <td class="td-2">
              <el-select v-model="detail.power_uids" placeholder="选择用户" style="width:500px;" multiple clearable @change="change_power_uids">
                <el-option v-for="item in $store.state.public.cfg.members_options" :key="item.uid" :label="item.user_name" :value="item.uid"></el-option>
              </el-select>  
            </td>
          </tr>
        </table>
      </div>
      <component
        :is="popName"
        :sku_id="edit_sku_id"
        :sku_row="edit_sku_row"
        :edit_row="edit_row"
        :goods_id="id"
        :goods="detail"
      ></component>
    </div>
  </div>
</template>
<script>
const editSku = (resolve) => require(["@/pages/goods/sku/_pop_edit"], resolve);
const editSkuModels = (resolve) => require(["@/pages/goods/sku/_pop_sku_models"], resolve);
const editTag = (resolve) => require(["@/pages/goods/tags/_pop_relation"], resolve);
const editLayer = (resolve) => require(["@/pages/goods/layers/_pop_edit_layer"], resolve);
export default {
  components: {
    editSku,
    editTag,
    editLayer,
    editSkuModels,
  },
  data() {
    return {
      loading: false,
      editModelPop: false,
      edit_row:null,
      edit_sku_row:null,
      id: 0,
      edit_sku_id: 0,
      adapters_models_loading: false,
      is_adapters_model_all:false,
      detail: null,
      popName: null,
      dialogImageUrl: "",
      dialogVisible: false,
      token: localStorage.getItem("token"),
      brand_options: [],
      series_options: [],
      model_options: [],
      shopify_sku_options: [],
      template_tag_options:[],
      goods_prompt_options: [],
    };
  },
  methods: {
    handleSuccessThumb(res, e) {
      if (res.code == 1) {
        this.detail.images.push({
          id: res.data.id,
          name: e.name,
          url: res.data.file_oss,
        });
        this.saveThumb();
      }
    },
    handleRemoveThumb(file, fileList) {
      this.detail.images = fileList;
      this.saveThumb();
    },
    saveThumb() {
      this.$http
        .post("/v1/pri/goods/save-images", {
          id: this.id,
          images: this.detail.images,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    handlePictureCardPreviewThumb(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeBrand() {
      this.getSeries();
    },
    changeSeries() {
      this.getModels();
    },
    handleSelectAll(val) {
      // val 就是当前全选框的状态 (true 或 false)
      if (val) {
        // 全选：将所有 model_options 的 id 赋给 v-model
        this.detail.adapters_model_ids = this.model_options.map(item => item.id);
      } else {
        // 取消全选：清空数组
        this.detail.adapters_model_ids = [];
      }
    },
    to_edit_layer(sku_id, layer) { 
      this.edit_sku_id = sku_id;
      this.edit_row = layer;
      this.popName = "editLayer"
    },
    to_apply_layer(sku) { 
      this.$confirm("确定应用", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$store.commit("setLoading", { text: "正在保存.." });
          this.$http
            .post("/v1/pri/goods-sku/apply-line-layer", { sku_id: sku.id, attribute_name_array:sku.apply_layer_mod })
            .then((response) => {
              this.$store.commit("setLoading", { text: false });
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getDetail()
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            })
            .catch((error) => {
              this.$message({
                message: error,
                type: "warning",
              });
              this.$store.commit("setLoading", { text: false });
            });
        });
    },
    to_apply_sku_image(sku) { 
      this.$confirm("确定应用", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$store.commit("setLoading", { text: "正在保存.." });
          this.$http
            .post("/v1/pri/goods-sku/apply-sku-image", { sku_id: sku.id, attribute_name_array:sku.apply_sku_mod })
            .then((response) => {
              this.$store.commit("setLoading", { text: false });
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.getDetail()
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            })
            .catch((error) => {
              this.$message({
                message: error,
                type: "warning",
              });
              this.$store.commit("setLoading", { text: false });
            });
        });
    },
    remove_layer(id) { 
      this.$confirm("删除图层", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$store.commit("setLoading", { text: "正在移除.." });
          this.$http
            .post("/v1/pri/goods-sku/remove-line-layer", { id: id })
            .then((response) => {
              this.$store.commit("setLoading", { text: false });
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: "移除成功",
                  type: "success",
                });
                this.getDetail()
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            })
            .catch((error) => {
              this.$store.commit("setLoading", { text: false });
            });
        });

    },
    getBrand(is_change) {
      this.$http
        .post("/v1/pri/diy-brand/lists", { page: 1, size: 1000 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.brand_options = res.data.list;
            this.series_options = [];
            this.model_options = [];
            if (is_change) {
              this.detail.diy_brand_id = this.brand_options[0].id;
              this.detail.diy_series_id = "";
            }
            this.getSeries();
          }
        });
    },
    getSeries() {
      this.$http
        .post("/v1/pri/diy-series/lists", {
          brand_id: (this.detail && this.detail.hasOwnProperty('diy_brand_id')) ? this.detail.diy_brand_id : 0,
          page: 1,
          size: 1000,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.series_options = res.data.list;
            this.model_options = [];
            this.getModels();
          }
        });
    },
    getModels() {
      this.$http
        .post("/v1/pri/diy-model/lists", {
          // brand_id: this.detail.diy_brand_id,
          // series_id: this.detail.diy_series_id,
          page: 1,
          size: 1000,
          status: 1,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.model_options = res.data.list;
          }
        });
    },
    changeModel() {
      this.$http
        .post("/v1/pri/goods/relation-model", {
          id: this.detail.id,
          model_id: this.detail.diy_model_id ? this.detail.diy_model_id : 0,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "关联成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });   
    },
    adapters_models() {
      if (this.adapters_models_loading) {
        return false;
      }

      this.adapters_models_loading = true;
      this.$http
        .post("/v1/pri/goods/adapter-model", {
          id: this.detail.id,
          model_ids: this.detail.adapters_model_ids,
        })
        .then((response2) => {
          this.adapters_models_loading = false;
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "关联成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        }).catch((err) => {
          console.log(err)
          this.adapters_models_loading = false;
        })
    },
    enableBgColor() {
      this.$http
        .post("/v1/pri/goods/enable-bg-color", {
          id: this.detail.id,
          enable_bg_color: this.detail.enable_bg_color_bool ? 1 : 2,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    enable_variant_image() {
      this.$http
        .post("/v1/pri/goods/enable-variant-image", {
          id: this.detail.id,
          enable_variant_image: this.detail.enable_variant_image_bool ? 1 : 2,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    getSkuIndexByRow(row) {
      var list = this.detail.sku_list;
      for (var i = 0; i < list.length; i++) {
        if (row.id == list[i].id) {
          return i;
        }
      }
      return 0;
    },
    uploadSkuLineImageSuccess(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/save-line-image", {
          id: row.id,
          line_image_id: response.data.id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$set(
              this.detail.sku_list[this.getSkuIndexByRow(row)],
              "line_image",
              response.data.file_oss
            );
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadSkuCameraImageSuccess(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/add-camera-image", {
          sku_id: row.id,
          file_id: response.data.id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadSkuCamera2ImageSuccess(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/add-camera2-image", {
          sku_id: row.id,
          file_id: response.data.id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadSkuImagesSuccess(response, file, fileList, row) {
      var index = this.get_arr_key_index(this.detail.sku_list, 'id', row.id);
      var sku_images = this.detail.sku_list[index].sku_images;
      if (!sku_images) sku_images = new Array();
      sku_images.push({
        file_id: response.data.id,
        file_oss: response.data.file_oss,
      })
      this.detail.sku_list[index].sku_images = sku_images

      this.$http
        .post("/v1/pri/goods-sku/save-sku-images", {
          sku_id: row.id,
          sku_images: sku_images,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadVideoImageSuccess(response, file, fileList) {
      this.saveField(this.detail.id, "video_cover", response.data.file_oss)
    },
    saveField(id, field_name, field_value) {
      this.$http
        .post("/v1/pri/goods/save-field", {
          id: id,
          field_name: field_name,
          field_value: field_value,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    removeCameraImage(sku_id, file_id) {
      this.$http
        .post("/v1/pri/goods-sku/del-camera-image", {
          sku_id: sku_id,
          file_id: file_id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    removeCamera2Image(sku_id, file_id) {
      this.$http
        .post("/v1/pri/goods-sku/del-camera2-image", {
          sku_id: sku_id,
          file_id: file_id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    removeSkuImage(row, sku_image_index) {
      var index = this.get_arr_key_index(this.detail.sku_list, 'id', row.id)
      var sku_images0 = this.detail.sku_list[index].sku_images;
      var sku_images = [];
      for (var i = 0; i < sku_images0.length; i++) {
        if (i != sku_image_index) {
          sku_images.push(JSON.parse(JSON.stringify(sku_images0[i])))
        }
      }
      this.$http
        .post("/v1/pri/goods-sku/save-sku-images", {
          sku_id: row.id,
          sku_images: sku_images,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    changeCameraColorValue(sku_row, color_item) {
      this.$http
        .post("/v1/pri/goods-sku/save-camera-color-value", {
          sku_id: sku_row.id,
          file_id: color_item.file_id,
          color_value: color_item.color_value,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    changeCamera2ColorValue(sku_row, color_item) {
      this.$http
        .post("/v1/pri/goods-sku/save-camera2-color-value", {
          sku_id: sku_row.id,
          file_id: color_item.file_id,
          color_value: color_item.color_value,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadSkuImageSuccess(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/save-image", {
          id: row.id,
          image: response.data.file_oss,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$set(
              this.detail.sku_list[this.getSkuIndexByRow(row)],
              "image",
              response.data.file_oss
            );
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    uploadSkuMaskImageSuccess(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/save-mask-image", {
          id: row.id,
          mask_image_id: response.data.id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$set(
              this.detail.sku_list[this.getSkuIndexByRow(row)],
              "mask_image",
              response.data.file_oss
            );
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    on_remove_sku_mask_image(row) { 
      this.$confirm("确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/v1/pri/goods-sku/remove-mask-image", { id: row.id })
          .then((response) => {
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              row.mask_image = "";
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
      });
    },
    upload_sku_prompt_style_image_success(response, file, fileList, row) {
      this.$http
        .post("/v1/pri/goods-sku/save-prompt-style-image", {
          id: row.id,
          prompt_style_image_id: response.data.id,
        })
        .then((response2) => {
          var res = response2.data;
          if (res.code == 1) {
            this.$set(
              this.detail.sku_list[this.getSkuIndexByRow(row)],
              "prompt_style_image",
              response.data.file_oss
            );
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    on_remove_sku_prompt_style_image(row) { 
      this.$confirm("确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/v1/pri/goods-sku/remove-prompt-style-image", { id: row.id })
          .then((response) => {
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              row.prompt_style_image = "";
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
      });
    },
    save_disabled_template_tag_ids() {
      console.log(this.detail.disabled_template_tag_ids)
      this.$http
        .post("/v1/pri/goods/save-disabled-template-tag-ids", {id:this.detail.id, tag_ids:this.detail.disabled_template_tag_ids})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "Save OK",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    save_recommend_template_tag_ids() {
      this.$http
        .post("/v1/pri/goods/save-recommend-template-tag-ids", {id:this.detail.id, tag_ids:this.detail.recommend_template_tag_ids})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "Save OK",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    getShopifySkuOptions() {
      this.$http
        .post("/v1/pri/shopify-product/variant-options", { page: 1, size: 1000 })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.shopify_sku_options = res.data.list;
          }
        });
    },
    relationShopifySku(row) {
      this.$http
        .post("/v1/pri/shopify-product/relation-sku", {
          system_sku_id: row.id,
          shopify_variant_id: row.shopify_variant_id ? row.shopify_variant_id : 0,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    change_field_price(sku_row, price_field) { 
      this.$confirm("修改价格[" + price_field +"]", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在修改.." });
        this.$http
          .post("/v1/pri/goods-sku/change-field-price", { id: sku_row.id, price_field:price_field, price_value:sku_row[price_field] })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setLoading", { text: false });
          });
      });
    },
    change_power_uids() {
      this.$store.commit("setLoading", { text: "正在修改.." });
      this.$http
        .post("/v1/pri/goods/save-power-uids", {id: this.detail.id, power_uids: this.detail.power_uids})
        .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
        });
    },
    getTemplateTags() {
      this.$http
        .post("/v1/pri/diy-template-tag/lists", {
          page: 1,
          size: 1000,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.template_tag_options = res.data.list
            console.log(this.template_tag_options)
          }
        });
    },
    toEditSku(id = 0) {
      this.edit_sku_id = id;
      this.popName = "editSku";
    },
    toAddTag() {
      this.popName = "editTag";
    },
    pop_sku_models(sku){
      this.edit_sku_row = sku;
      this.popName = "editSkuModels"
    },
    removeTag(tag) {
      this.$http
        .post("/v1/pri/goods-tags/remove-relation", {
          relation_id: tag.id,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    //设置默认SKU
    setSkuDefault() {
      this.$http
        .post("/v1/pri/goods-sku/set-default", {
          id: this.detail.default_sku_id,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    //上架下架
    setSkuStatus(sku) {
      this.$store.commit("setLoading", { text: "正在提交.." });
      this.$http
        .post("/v1/pri/goods-sku/set-status", {
          id: sku.id,
          status: sku.status_bool ? 1 : 2,
        })
        .then((response) => {
          this.$store.commit("setLoading", { text: false });
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          this.$store.commit("setLoading", { text: false });
        });
    },
    //是否开启预览按钮
    setSkuPreviewBtnStatus(sku) {
      this.$store.commit("setLoading", { text: "正在提交.." });
      this.$http
        .post("/v1/pri/goods-sku/set-enable-preview-btn", {
          id: sku.id,
          enable_preview_btn: sku.enable_preview_btn_bool ? 1 : 0,
        })
        .then((response) => {
          this.$store.commit("setLoading", { text: false });
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          this.$store.commit("setLoading", { text: false });
        });
    },
    setSkuStock(sku) {
      this.$store.commit("setLoading", { text: "正在提交.." });
      this.$http
        .post("/v1/pri/goods-sku/set-stock", {
          id: sku.id,
          count_stock: sku.count_stock,
        })
        .then((response) => {
          this.$store.commit("setLoading", { text: false });
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail(false);
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          this.$store.commit("setLoading", { text: false });
        });
    },
    changeCanvsSize(sku) {
      this.$store.commit("setLoading", { text: "正在提交.." });
      this.$http
        .post("/v1/pri/goods-sku/set-canvas-size", {
          id: sku.id,
          canvas_size: sku.canvas_size,
        })
        .then((response) => {
          this.$store.commit("setLoading", { text: false });
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        })
    },
    //删除某个SKU
    removeSku(id) {
      this.$confirm("删除SKU", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在移除.." });
        this.$http
          .post("/goods/sku/remove", { id: id })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              var list = [];
              for (var i = 0; i < this.detail.sku_list.length; i++) {
                if (this.detail.sku_list[i].id != id) {
                  list.push(this.detail.sku_list[i]);
                }
              }
              this.detail.sku_list = list;
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setLoading", { text: false });
          });
      });
    },
    //获取详情
    getDetail(is_loading = true) {
      if (is_loading) this.loading = true;
      this.$http
        .post("/v1/pri/goods/detail", { id: this.id })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.detail = res.data;
            if (this.detail.diy_model_id) {
              this.getModels();
            } else {
              this.getBrand(false);
            }
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$store.commit('set_current_menu', {name:'goods'});
    this.id = this.getUrlParam("id");
    this.getDetail();
    this.getShopifySkuOptions()
    this.getTemplateTags();
    this.getBrand();
  },
};
</script>
<style>
.goods-detail-page {
  background-color: rgb(244, 244, 244);
}
.goods-detail-page .he-tips {
  margin-bottom: 10px;
  position: relative;
}
.goods-detail-page .he-tips .handle-s {
  position: absolute;
  top: 0;
  right: 0;
}
.goods-detail-page .o-detail-con {
  margin: 0 auto;
}
.goods-detail-page .o-d-block {
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.goods-detail-page .o-detail-con .o-main {
  margin-bottom: 300px;
}
.goods-detail-page .table td {
  border: 1px solid #efefef;
  background: #fff;
}
.goods-detail-page .channles-table td {
  padding: 5px;
}
.goods-detail-page .channles-table .el-switch__core {
  height: 18px;
}
.goods-detail-page .channles-table .el-switch__core:after {
  height: 13px;
  width: 13px;
}
</style>


// WEBPACK FOOTER //
// src/pages/goods/Detail.vue